import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.545 6.347v4.82a2.62 2.62 0 0 1-2.61 2.62h-7.86a2.623 2.623 0 0 1-2.62-2.62v-6.34a2.623 2.623 0 0 1 2.62-2.62h3.17a.744.744 0 0 1 .52.22l1.31 1.3h2.86a2.62 2.62 0 0 1 2.61 2.62Z';
const draw24px =
  'M21.61,9.48v7.37A3.61,3.61,0,0,1,18,20.45H6a3.61,3.61,0,0,1-3.61-3.6V7.15A3.61,3.61,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.11,2.1H18A3.61,3.61,0,0,1,21.61,9.48Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FolderFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'folderFilled'),
) as IconWithRender;

FolderFilledIcon.displayName = 'FolderFilledIcon';
FolderFilledIcon.propTypes = Icon.propTypes;
FolderFilledIcon.renderIcon = (props) => <FolderFilledIcon {...props} />;
export default FolderFilledIcon;
